import { render } from "./ManageCustomers.vue?vue&type=template&id=0b3ee0d6&scoped=true"
import script from "./ManageCustomers.vue?vue&type=script&lang=js"
export * from "./ManageCustomers.vue?vue&type=script&lang=js"

import "./ManageCustomers.vue?vue&type=style&index=0&id=0b3ee0d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3ee0d6"]])

export default __exports__